import {z} from '@hono/zod-openapi';

import {count} from './count';
import {DeadStockMonthSchema} from './DeadStockMonthSchema';

export const DeadStockResponseSchema = z
  .object({
    capturedAt: z.string(),
    timezone: z.string(),
    months: z.array(DeadStockMonthSchema),
    /**
     * The same age buckets restricted to cards without any historical issue. Their age
     * starts at the first movement that put stock on hand. Defaults for rolling deploys
     * where the DMS can receive a response from an older reporting API.
     */
    neverIssuedMonths: z.array(DeadStockMonthSchema).default([]),
    /**
     * Cards whose value could not be determined because a contributing movement is
     * unpriced. Reported so the UI can show a data-quality note; the report itself stays
     * available rather than failing tenant-wide on a single ambiguous card.
     */
    invalidBalanceCount: count.default(0),
  })
  .openapi('DeadStockResponse');

export type DeadStockResponse = z.infer<typeof DeadStockResponseSchema>;
